import { SrInsightType as InsightType } from '@plato/data/starrocks/types';
import type { TranslationFunction } from '../../../lib/hooks/use-locale.ts';
import type {
    ChurnDimension,
    InsightDTO,
    ResolvedOutcomeInsightDTO,
} from '../../../server/dto/insight-dto.ts';
import { churnV2CardDimension } from '../components/churn-v2-dimension.ts';

export const dimensionTitleKey: Record<ChurnDimension, string> = {
    d1_silence: 'churn_v2_title__d1_silence',
    d2_cadence: 'churn_v2_title__d2_cadence',
    d3_annual: 'churn_v2_title__d3_annual',
    d4_seasonal: 'churn_v2_title__d4_seasonal',
    d5_revenue: 'churn_v2_title__d5_revenue',
    d6_momentum: 'churn_v2_title__d6_momentum',
    d7_concentration: 'churn_v2_title__d7_concentration',
    d8_global: 'churn_v2_title__d8_global',
};

export function getInsightName(
    t: TranslationFunction,
    insight: InsightDTO | ResolvedOutcomeInsightDTO,
): string {
    if (insight.insight_type === InsightType.INDUSTRY_TOP) {
        return t(`insight_name__${insight.insight_type}`, {
            ns: 'insights',
            industry_sector: insight.template_arguments?.industry_sector,
        });
    }

    if (insight.insight_type === InsightType.CHURN_WARNING) {
        const args = insight.template_arguments;
        // Only v2 churn carries dimensions; v1 and resolved outcomes get the generic name.
        // Same selector as the tooltip and body text, so the heading cannot contradict them.
        const dim = args && 'top_dimension_1' in args ? churnV2CardDimension(args) : undefined;

        return dim
            ? t(dimensionTitleKey[dim], { ns: 'insights' })
            : t(`insight_name__${InsightType.CHURN_WARNING}`, { ns: 'insights' });
    }

    return t(`insight_name__${insight.insight_type}`, {
        ns: 'insights',
    });
}
